// Mirrors Company.BUSINESS_TYPE_CHOICES on the backend; the type shapes the
// departments, roles, and defaults the setup assistant recommends. Exported
// so the review page labels every choice from the same list.
export const BUSINESS_TYPES = [
  {
    value: 'quick_service_restaurant',
    title: 'Quick-Service Restaurant',
    description: 'Counter service or fast casual: one department is usually enough.',
  },
  {
    value: 'full_service_restaurant',
    title: 'Full-Service Restaurant',
    description: 'Table service: front of house and back of house are often scheduled separately.',
  },
  {
    value: 'bar',
    title: 'Bar',
    description: 'Bar, pub, or taproom: bartenders, barbacks, and door staff.',
  },
  {
    value: 'cafe',
    title: 'Cafe or Coffee Shop',
    description: 'Baristas, cashiers, and bakers, usually in one department.',
  },
  {
    value: 'retail',
    title: 'Retail',
    description: 'Sales associates, cashiers, and stock, usually in one department.',
  },
  {
    value: 'hotel',
    title: 'Hotel',
    description: 'Front desk, housekeeping, and food and beverage teams.',
  },
  {
    value: 'other',
    title: 'Something else',
    description: 'Rightwork starts with one department; the setup assistant tailors the rest.',
  },
];

